// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"becfbbe3","container":"b6ef66b7","signatureImageContainer":"a2851657","signatureImage":"a61ebf67"};